<template>
  <div class="mt3 w-100 w-auto-ns">
    <div class="flex flex-row justify-center">
      <a class="flex flex-row items-center justify-center w-50 f6 glow hover-bg-blue hover-white link ba ph3 pv2 mb2 dib blue pointer br2" :hymnalName="hymnalName" @click="$router.go(-2)">
        <i class="f4 fas fa-caret-left"></i>
        <span class="ph2">Go Back</span>
      </a>
    </div>
    <div>
      <p>The page you requested doesn't exist.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'error',
  props: {
    page: {
      type: Number,
      required: false
    },
    hymnal: {
      type: String,
      required: true
    },
    hymns: {
      type: Array,
      required: true
    },
    hymnalName: {
      type: String,
      required: true
    }
  }
}
</script>

<style>

</style>
